import {Jurisdiction, NotOfferedJurisdiction} from './constants'

// Neutral globe used for codes we recognise but have no artwork for.
const FALLBACK_FLAG_CODE = 'xx'

const FLAG_CODES: string[] = [
  ...Object.values(Jurisdiction),
  ...Object.values(NotOfferedJurisdiction),
]

const getFlagCode = (jurisdiction: string): string | null =>
  FLAG_CODES.includes(jurisdiction) ? jurisdiction.toLowerCase() : null

export const getJurisdictionFlagSrc = (jurisdiction: string): string | null => {
  const flagCode = getFlagCode(jurisdiction)

  return flagCode && `/images/flags/${flagCode}-flag.svg`
}

export const getJurisdictionEmailFlagSrc = (jurisdiction: string): string =>
  `/images/emails/flags/${getFlagCode(jurisdiction) ?? FALLBACK_FLAG_CODE}-flag.png`
